"use strict";

var agendorAPI = require("app/util/api/agendor-api");

module.exports.get = function get(success, error) {
  var responseHandler = agendorAPI.getResponseHandler(success, error);
  agendorAPI.get("/loss_reasons", null, responseHandler);
};



// WEBPACK FOOTER //
// ./app/util/api/loss-reasons.js